import React, { useCallback, useState } from "react";
import { Button, Fade, Modal, Backdrop } from "@material-ui/core";
import CloseIcon from "../../../assets/svgs/closeIcon.svg";
import { injected } from "../../../utils/web3Connectors";
import MetamaskLogo from "../../../assets/images/MetamaskLogo.png";
import useStyles from "./disconnectWalletStyles";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import { ClassSharp } from "@material-ui/icons";
import CopyIcon from "../../../assets/svgs/copy.svg";
import ViewIcon from "../../../assets/svgs/viewOnExplorer.svg";
import { conciseAddress } from "../../../utils/formatters";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import Notify from "../../Toast/Notify";
import { ETHERSCAN_ACCOUNT_LINK_RINKBY } from "../../../contract/constant";
import ConnectWalletModal from "../ConnectWalletModal/ConnectWalletModal";
import ConnectWalletButton from "../../Buttons/ConnectWallet/ConnectWalletButton";

function DisconnectWallet({ open, handleClose }) {
  const classes = useStyles();
  const [changeModalOpen, setChangeModalOpen] = useState(false);
  const [changeOpen, setChangeOpen] = useState(false);
  const { account, active, connector, deactivate, library, chainId } =
    useWeb3React();

    const handleChangeWallet = () => {
        setChangeModalOpen(true);
      };

      const handleChangeOpen = () => {
        setChangeOpen(true);
      };
    
      const handleChangeClose = () => {
        setChangeOpen(false);
      };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div>
              <div className={classes.connectWallet}>
                <div className={classes.connectWalletText}>Account</div>
                <div onClick={handleClose}>
                  <img src={CloseIcon} className={classes.closeIcon} />
                </div>
              </div>
              <div className={classes.walletList}>
                <div className={classes.walletItem}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent:"space-between" }}>
                    <div className={classes.disconnectWalletTitle}>
                      {(localStorage.getItem("previousWallet"))&&`Connected with ${localStorage.getItem("previousWallet")=="metaMask"?"Metamask" :(localStorage.getItem("previousWallet")=="walletConnect")?"Wallet Connect":""}`}
                    </div>
                    {/* <div className={classes.WalletIcon}>Change</div> */}
                    <div>
                    <ConnectWalletButton
              handleOpen={handleChangeOpen}
              handleClose={handleChangeClose}
              open={changeOpen}
              text={"Change"}
              padding={"3px 15px"}
            />
            <ConnectWalletModal
              handleOpen={handleChangeOpen}
              handleClose={handleChangeClose}
              open={changeOpen}
              text={"Change"}
            />
                      </div>
                  </div>
                  <div className={classes.accountDetailsDiv}>
                    <div className={classes.accountAddress}>
                      {conciseAddress(account)}
                    </div>
                  </div>
                  <div className={classes.disconnectFunctions}>
                  <CopyToClipboard
                    text={account}
                    onCopy={() => {
                      toast(
                        <Notify
                          text={("success", "Address copied to clipboard")}
                          severity="success"
                        />,
                        {
                          position: "bottom-right",
                        }
                      );
                    }}
                  >
                    <div className={classes.disconnectFunctionsItem}>
                      <div className={classes.Link}>
                        <div>
                            <img src={CopyIcon}/>
                            </div>
                            <div style={{marginLeft:"5px"}}>
                      Copy Address
                                </div>
                    </div>
                    </div>
                    </CopyToClipboard>
                    <a
                    href={ETHERSCAN_ACCOUNT_LINK_RINKBY + account}
                    rel="external nofollow noopener"
                    target="_blank"
                    className={classes.Link}
                  >
                    <div className={classes.disconnectFunctionsItem} style={{marginLeft:"10px"}}>
                    <div>
                    <img src={ViewIcon}/>
                            </div>
                            <div style={{marginLeft:"5px"}}>
                        View on Explorer
                                </div>
                        </div>
                  </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default DisconnectWallet;
